import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { CommonService } from 'src/app/modules/shared/services/common.service';
import { UploaderMessages } from '../../../shared/models/component-messages/uploader-messages';
import { ErrorMessages } from '../../../shared/models/component-messages/error-messages';

@Component({
  selector: 'app-uploader-v2',
  templateUrl: './uploader-v2.component.html',
  styleUrls: ['./uploader-v2.component.scss']
})
export class UploaderV2Component implements OnInit {

  @Input() title: string;
  @Input() size: number;
  @Input() type: string;
  @Input() required: boolean;
  @Output() errorSizeEvent = new EventEmitter<string>();
  @Output() validationMessageEvent = new EventEmitter<string>();
  @Output() errorLengthEvent = new EventEmitter<string>();
  @Output() uploadEvent = new EventEmitter<File>();
  @Output() deleteFileEvent = new EventEmitter<string>();

  private twentyMoOnByte = 1048576;
  private twentyMo = 20;
  @ViewChild('attachments', {static: false}) attachment: any;

  public files: any = [];
  public fileName: string;
  public errorLength: string;
  public errorSize: string;
  public validationMessage: string;
  public uploaderMessages = new UploaderMessages();
  public deleted = false;
  public errorMessages = new ErrorMessages();

  constructor(private commonService: CommonService) {
  }

  public ngOnInit() {
  }

  public uploadFile(event) {
    const eventObj = event as MSInputMethodContext;
    const target = eventObj.target as HTMLInputElement;
    this.errorLength = '';
    this.errorSize = '';
    this.validationMessage = '';

    const file: File = target.files[0];
    if (this.commonService.checkFileSize(file.size)) {
      this.fileName = this.commonService.truncateFileName(file.name);
      if (this.files.length < this.size) {
        this.files.push(this.fileName);
      } else {
        if (this.files.length === this.size) {
          this.errorLength = '';
          this.files.splice(0, 1, this.fileName);
        }
      }
    } else {
      this.errorSize = 'error';
    }
    this.uploadEvent.emit(file);
    this.attachment.nativeElement.value = '';
    this.validationMessageEvent.emit(this.validationMessage);
    this.errorLengthEvent.emit(this.errorLength);
    this.errorSizeEvent.emit(this.errorSize);
    this.deleted=false;
  }

  public uploadFileDropped(event) {
    this.errorLength = '';
    this.errorSize = '';
    this.validationMessage = '';

    if (event.length > this.size) {
      this.errorLength = 'error';
    } else {
      for (const file of event) {
        if (this.commonService.checkFileSize(file.size)) {
          this.fileName = this.commonService.truncateFileName(file.name);
          if (this.files.length < this.size) {
            this.files.push(this.fileName);
          } else {
            if (this.files.length === this.size) {
              this.errorLength = '';
              this.files.splice(0, 1, this.fileName);
              this.uploadEvent.emit(file);
            }
          }
        } else {
          this.errorSize = 'error';
        }
      }
    }
    this.validationMessageEvent.emit(this.validationMessage);
    this.errorSizeEvent.emit(this.errorSize);
    this.errorLengthEvent.emit(this.errorLength);
  }

  public deleteAttachment(i) {
    this.errorLength = '';
    this.errorSize = '';
    this.validationMessage = '';
    this.files.splice(i, 1);
    this.validationMessageEvent.emit(this.validationMessage);
    this.errorSizeEvent.emit(this.errorSize);
    this.errorLengthEvent.emit(this.errorLength);
    this.deleteFileEvent.emit(this.type);
    this.deleted = true;
  }

  public isEnterPressed(event, targetID) {
    const target = event.target;
    target.addEventListener("keyup", (keyEvent) => {
      if (keyEvent.key === "Enter") {
        keyEvent.preventDefault();
        document.getElementById(targetID).click();
      }
    })
  }
}
